import { observer } from 'mobx-react';
import { Maybe } from 'maybeasy';
import { Typography, emptyFragment } from '@execonline-inc/execonline-ui';
import { T } from '../../../../../../../../Translations';

interface Props {
  hours: Maybe<number>;
}

function ProgramHours({ hours }: Props) {
  return hours
    .map((count) => (
      <Typography className="text-gray-900" variant="caption">
        <T kind="{{count}} Hour" count={count} />
      </Typography>
    ))
    .getOrElse(emptyFragment);
}

export default observer(ProgramHours);
